/** Static copy for career workspace feature preview on the landing page. */
export const CAREER_WORKSPACE_PREVIEW = {
  title: 'Your entire job search in one place',
  actionsBadge: '9 actions',
  sessions: 'Sessions',
  sessionNow: 'now',
  session2hAgo: '2h ago',
  sessionYesterday: 'yesterday',
  sessionStripePrep: 'Stripe PM prep',
  sessionMicrosoftOptimize: 'Microsoft optimize',
  sessionProfileAssessment: 'Profile assessment',
  agentBrand: 'GoGrabJob Agent',
  agentRole: 'Agent',
  you: 'You',
  live: 'Live',
  profileContextInjected: 'Profile context injected',
  profileTagName: 'Alex Rivera',
  profileTagSeniority: 'Senior PM · 6 yrs',
  profileTagSkills: 'B2B SaaS · Roadmaps · SQL',
  profileTagLocation: 'Remote · Open to Bengaluru',
  quickActions: 'Quick actions',
  chipAboutProfile: 'About my profile',
  chipAboutProfileDesc: 'Strengths & gaps',
  chipRecommendedJobs: 'Recommended jobs',
  chipRecommendedJobsDesc: 'Profile-matched roles',
  chipSkillAssessment: 'Skill assessment',
  chipSkillAssessmentDesc: 'Benchmark skills',
  chipOptimizeResume: 'Optimize resume',
  chipOptimizeResumeDesc: 'ATS keywords',
  chipCoverLetter: 'Cover letter',
  chipCoverLetterDesc: 'Tailored per role',
  chipApplicationLetter: 'Application letter',
  chipApplicationLetterDesc: 'Direct / referred',
  userMessage:
    'Research Stripe for my interview and draft a cover letter for Senior PM.',
  researchAction:
    'Running company research via Exa — pulling live sources for Stripe.',
  letterThinking:
    'Drafting ATS-aware cover letter using your profile + Stripe research…',
  letterReady:
    'Cover letter ready — tailored to Senior PM at Stripe using your B2B SaaS metrics.',
  recordOffer:
    'Saved to your workspace — company research, cover letter, and application record linked to Stripe PM.',
  promptHint: 'Ask agent anything…',
  companyResearch: 'Company research',
  exaLive: 'Exa live',
  researchOverview: 'Overview',
  researchOverviewBody:
    'Stripe builds economic infrastructure for the internet — payments, billing, and embedded finance APIs used by millions of businesses globally.',
  researchRecentNews: 'Recent News',
  researchRecentNewsBody:
    'Expanded enterprise suite in APAC; new AI-assisted fraud tools; continued hiring across product & platform teams in Bangalore.',
  researchProduct: 'Product',
  researchProductBody:
    'Core products: Payments, Connect, Billing, Terminal. Platform PM roles focus on developer experience and enterprise adoption loops.',
  researchCulture: 'Culture & Reviews',
  researchCultureBody:
    'High bar for written communication; strong product-engineering partnership; remote-friendly with async-first rituals.',
  researchInterviewTopics: 'Likely Interview Topics',
  researchInterviewTopicsBody:
    '0→1 platform bets, metrics-driven roadmaps, API developer experience, and cross-functional stakeholder management.',
  savedArtifacts: 'Saved artifacts',
  savedArtifactsCount: '5 items',
  artifactCompanyResearch: 'Company research · Stripe',
  artifactCoverLetter: 'Cover letter · Stripe PM',
  artifactOptimization: 'Optimization · Microsoft PM',
  artifactApplicationLetter: 'Application letter · Tata',
  artifactProfileAssessment: 'Profile assessment',
  artifactJustNow: 'just now',
  artifact2hAgo: '2h ago',
  artifactYesterday: 'yesterday',
  artifact2dAgo: '2d ago',
  artifactKindCompanyResearch: 'COMPANY RESEARCH',
  artifactKindCoverLetter: 'COVER LETTER',
  artifactKindOptimization: 'OPTIMIZATION SUMMARY',
  artifactKindApplicationLetter: 'APPLICATION LETTER',
  artifactKindProfileAssessment: 'PROFILE ASSESSMENT',
} as const;

export type CareerWorkspacePreviewCopy = typeof CAREER_WORKSPACE_PREVIEW;
